export type DateRange = 'all' | 'last_30d' | 'last_6m' | 'last_1y' | 'custom';
export type StudyType = 'all' | 'tte' | 'stress_echo' | 'other';

export const DATE_RANGE_LABELS: Record<DateRange, string> = {
  all: 'All time',
  last_30d: 'Last 30 days',
  last_6m: 'Last 6 months',
  last_1y: 'Last year',
  custom: 'Custom',
};

export const STUDY_TYPE_LABELS: Record<StudyType, string> = {
  all: 'All types',
  tte: 'TTE',
  stress_echo: 'Stress Echo',
  other: 'Other',
};
